import React from 'react';
import { useLang } from '../contexts/LanguageContext';
import { useSiteConfig, pickI18n } from '../contexts/SiteConfigContext';
import PageBanner from '../components/PageBanner';

const ProductsPage = () => {
  const { lang } = useLang();
  const { config } = useSiteConfig();
  const colors = config.identity?.colors || {};
  const products = (config.products || []).filter((p) => p.visible !== false);

  const tag = lang === 'de' ? 'Produkte' : lang === 'ar' ? 'المنتجات' : 'Products';
  const title = lang === 'de' ? 'Unsere Produkte' : lang === 'ar' ? 'منتجاتنا' : 'Our Products';

  return (
    <>
      <PageBanner tag={tag} title={title} />
      <section className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {products.length === 0 ? (
            <p className="text-center text-gray-500 py-12">
              {lang === 'de' ? 'Bald verfügbar.' : lang === 'ar' ? 'قريباً' : 'Coming soon.'}
            </p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {products.map((p) => (
                <div
                  key={p.id}
                  className="bg-white rounded-2xl overflow-hidden hover:-translate-y-1 transition-transform duration-500"
                  style={{ boxShadow: '0 1px 3px rgba(196, 71, 122, 0.06), 0 8px 24px -10px rgba(196, 71, 122, 0.12)' }}
                >
                  {p.image && (
                    <div className="aspect-square overflow-hidden bg-gray-50">
                      <img src={p.image} alt="" className="w-full h-full object-cover" loading="lazy" />
                    </div>
                  )}
                  <div className="p-5">
                    <h3
                      className="font-display mb-2"
                      style={{ color: colors.text_dark, fontWeight: 500, fontSize: '1.1rem' }}
                    >
                      {pickI18n(p.name, lang)}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed line-clamp-2 mb-3">
                      {pickI18n(p.description, lang)}
                    </p>
                    {p.price && (
                      <p className="font-medium" style={{ color: colors.primary }}>
                        {p.price}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default ProductsPage;
